import { render, staticRenderFns } from "./EtapaCasoSidebar.vue?vue&type=template&id=b55ef056&scoped=true"
import script from "./EtapaCasoSidebar.vue?vue&type=script&lang=js"
export * from "./EtapaCasoSidebar.vue?vue&type=script&lang=js"
import style0 from "./EtapaCasoSidebar.vue?vue&type=style&index=0&id=b55ef056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55ef056",
  null
  
)

export default component.exports